import AnnouncementsService from "@/api/services/announcements";
import { toCamelCase } from "@estaly/ui";

// Announcements targeting the signed-in merchant user, as filtered by the API. The modal shows the first one
// this user has not closed yet on this browser, or the one reopened from the sidebar.
const seenStorageKey = (userId) => `estaly_announcements_seen_${userId}`;

function readSeenSlugs(userId) {
  try {
    const slugs = JSON.parse(localStorage.getItem(seenStorageKey(userId)) || "[]");
    return Array.isArray(slugs) ? slugs : [];
  } catch {
    return [];
  }
}

export default {
  namespaced: true,

  state: {
    announcements: [],
    seenSlugs: [],
    reopenedSlug: null,
  },

  getters: {
    modalAnnouncement: (state) =>
      state.announcements.find(({ slug }) => slug === state.reopenedSlug) ??
      state.announcements.find(({ slug }) => !state.seenSlugs.includes(slug)) ??
      null,

    navAnnouncement: (state) => state.announcements.find((announcement) => announcement.navButton) ?? null,
  },

  mutations: {
    SET_ANNOUNCEMENTS(state, announcements) {
      state.announcements = announcements;
    },
    SET_SEEN_SLUGS(state, slugs) {
      state.seenSlugs = slugs;
    },
    SET_REOPENED_SLUG(state, slug) {
      state.reopenedSlug = slug;
    },
  },

  actions: {
    async fetchIndex({ commit, rootState }) {
      const response = await AnnouncementsService.fetchIndex();
      if (!response?.success) return response;

      commit("SET_SEEN_SLUGS", readSeenSlugs(rootState.auth.currentUser?.id));
      commit("SET_ANNOUNCEMENTS", toCamelCase(response.data).announcements);
      return response;
    },

    reopen({ commit }, slug) {
      commit("SET_REOPENED_SLUG", slug);
    },

    close({ commit, state, rootState }, slug) {
      commit("SET_REOPENED_SLUG", null);
      if (state.seenSlugs.includes(slug)) return;

      const seenSlugs = [...state.seenSlugs, slug];
      commit("SET_SEEN_SLUGS", seenSlugs);
      try {
        localStorage.setItem(seenStorageKey(rootState.auth.currentUser?.id), JSON.stringify(seenSlugs));
      } catch {
        // Storage unavailable (private mode): the announcement shows again at the next visit
      }
    },
  },
};
